import {FunctionComponent} from "react";
import { Link } from "react-router-dom";

export const Privacy: FunctionComponent = () => {
    return (
        <div>
            <h1>Privacy Policy</h1>
            <ul>
                <li>
                    <Link to={"/privacy/ios/"}>
                        iOS (including iPhone and iPad)
                    </Link>
                </li>
            </ul>
        </div>
    )
}